import { injectable } from 'inversify';

@injectable()
abstract class RpcRequestTracker {
  abstract start(method: string): void;
  abstract end(method: string): void;
}

export { RpcRequestTracker };
